import { gql } from '@apollo/client';

export const ANALYTICS_COMPONENT_FIELDS = gql`
  fragment AnalyticsComponentFields on AnalyticsComponent {
    id
    projectId
    dashboardId
    kind
    chartType
    title
    description
    spec
    layout {
      x
      y
      w
      h
      minW
      minH
    }
    generationMetadata
    createdAt
    updatedAt
    isStale
    resolvedValues {
      dataPointId
      title
      type
      subtype
      value
      updatedAt
      fingerprint
      isStale
    }
    sourceRefs {
      id
      dataPointId
      fingerprint
      currentFingerprint
      snapshot
      isStale
      updatedAt
    }
  }
`;

export const GET_ANALYTICS_DASHBOARDS = gql`
  query GetAnalyticsDashboards($projectId: ID!, $reportId: ID) {
    analyticsDashboards(projectId: $projectId, reportId: $reportId) {
      id
      projectId
      ownerId
      reportId
      title
      description
      accessScope
      layout
      createdAt
      updatedAt
      isStale
      canEdit
      canManageAccess
      members {
        id
        userId
        role
      }
      components {
        id
        kind
        chartType
        title
        isStale
      }
    }
  }
`;

export const GET_ANALYTICS_DASHBOARD = gql`
  ${ANALYTICS_COMPONENT_FIELDS}
  query GetAnalyticsDashboard($id: ID!, $projectId: ID!) {
    analyticsDashboard(id: $id, projectId: $projectId) {
      id
      projectId
      ownerId
      reportId
      title
      description
      accessScope
      layout
      createdAt
      updatedAt
      isStale
      canEdit
      canManageAccess
      members {
        id
        userId
        role
        user {
          id
          firstName
          lastName
          email
        }
      }
      components {
        ...AnalyticsComponentFields
      }
    }
  }
`;

export const GET_ANALYTICS_COMPONENTS = gql`
  ${ANALYTICS_COMPONENT_FIELDS}
  query GetAnalyticsComponents($input: AnalyticsComponentsFilterInput!) {
    analyticsComponents(input: $input) {
      nodes {
        ...AnalyticsComponentFields
      }
      pageInfo {
        hasMore
        nextCursor
      }
    }
  }
`;
